import {
  Component,
  EventEmitter,
  Input,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';

@Component({
    selector: 'c-multi-item',
    templateUrl: './multi-item.component.html',
    styleUrl: './multi-item.component.css',
    standalone: false
})
export class MultiItemComponent {
  show = false;
  check = false;
  partial = false;

  @Input() data!: any;
  @Input() subData!: string;
  @Input() itemProperty!: string;
  @Input() subItemProperty!: string;
  @Input() itemDescriptionProp!: string;
  @Input() subDescriptionProp!: string;
  @Input() identificadorI!: string;
  @Input() identificadorS!: string;
  @Input() parentOnly = false;

  @Output() selectedData = new EventEmitter<any>();

  selectedItems!: any;

  // ✅ NUEVO
  get hasSubItems() {
    return this.subData && this.data?.[this.subData];
  }

  // -------------------------
  // INIT
  // -------------------------
  initData(initData: any) {
    // 👉 modo SIN subitems
    if (!this.hasSubItems) {
      this.check = initData !== undefined;
      this.selectedItems = this.check ? this.data : undefined;
      return;
    }

    // 👉 modo CON subitems
    const initIds = initData
      ? initData[this.subData]?.map((j: any) =>
          j[this.identificadorS] ? j[this.identificadorS] : j
        )
      : [];

    if (this.parentOnly) {
      this.check = initData !== undefined;
      this.selectedItem(this.check);
    } else {
      this.check =
        initData !== undefined &&
        (initData[this.subData]?.length === 0 || !initData[this.subData]);
      if (this.check) this.selectedItem(this.check);
    }

    if (initIds?.length) {
      this.data[this.subData].forEach((i: any) => {
        const id = i[this.identificadorS] ? i[this.identificadorS] : i;
        i['check'] = initIds.includes(id);
        this.selectedSubItem(i['check'], i);
      });
    }
  }

  // -------------------------
  // HELPERS
  // -------------------------
  returnName(item: any) {
    return this.itemProperty
      ? item[this.itemProperty] ?? item[this.subItemProperty]
      : item;
  }

  // -------------------------
  // SUB ITEMS
  // -------------------------
  selectedSubItem(check: boolean, item: any) {
    if (!this.hasSubItems) return;

    const { check: _, ...data } = item;

    if (!this.selectedItems) {
      this.selectedItems = { ...this.data, [this.subData]: [] };
    }

    const i = this.selectedItems[this.subData].find(
      (d: any) => JSON.stringify(d) === JSON.stringify(data)
    );

    if (check && !i) this.selectedItems[this.subData].push(data);
    else {
      const index = this.selectedItems[this.subData].findIndex(
        (d: any) => JSON.stringify(d) === JSON.stringify(data)
      );
      if (index !== -1) this.selectedItems[this.subData].splice(index, 1);
    }

    if (
      this.selectedItems[this.subData].length ===
      this.data[this.subData].length
    ) {
      this.partial = false;
      this.check = true;
    } else {
      if (this.selectedItems[this.subData].length === 0 && !this.parentOnly) {
        this.selectedItems = undefined;
        this.partial = false;
      } else {
        this.partial = true;
      }
      this.check = this.parentOnly ? true : false;
    }

    this.selectedData.emit(this.selectedItems);
  }

  // -------------------------
  // PARENT
  // -------------------------
  @ViewChildren('check') checkboxes!: QueryList<HTMLInputElement>;

  selectedItem(check: boolean) {
    // 👉 modo SIN subitems
    if (!this.hasSubItems) {
      this.selectedItems = check ? this.data : undefined;
      this.partial = false;
      this.selectedData.emit(this.selectedItems);
      return;
    }

    // 👉 modo CON subitems
    this.data[this.subData].forEach((i: any) => {
      i.check = this.parentOnly && check ? i.check : check;
    });

    if (!this.selectedItems) {
      this.selectedItems = { ...this.data, [this.subData]: [] };
    }

    if (check) {
      if (!this.parentOnly) {
        this.selectedItems = {
          ...this.data,
          [this.subData]: this.data[this.subData].map((i: any) => {
            const { check: _, ...d } = i;
            return d;
          }),
        };
      } else {
        this.selectedItems = { ...this.data, [this.subData]: [] };
      }
    } else {
      this.selectedItems = undefined;
    }

    this.selectedData.emit(this.selectedItems);

    this.partial = !(this.selectedItems
      ? this.selectedItems[this.subData].length ===
        this.data[this.subData].length
      : true);
  }
}
